import { render, staticRenderFns } from "./customer-register-stockist.vue?vue&type=template&id=64758b76&"
import script from "./customer-register-stockist.vue?vue&type=script&lang=js&"
export * from "./customer-register-stockist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports